// react-frontend/src/admin/bookings/CancelledBookings.js
import React from 'react';
import AllBookings from './AllBookings';

const CancelledBookings = () => {
  return <AllBookings defaultTab="cancelled" />;
};

export default CancelledBookings;